import { logWrapper } from '../../utils';
import swal from 'sweetalert2';

export default {
  timecheckController: [
    'runtimeConstant',
    '$scope',
    '$rootScope',
    '$uibModal',
    '$state',
    '$filter',
    'userCrudService',
    'userSelected',
    function (
      runtimeConstant,
      $scope,
      $rootScope,
      uibModal,
      $state,
      $filter,
      userCrudService,
      userSelected
    ) {
      'use strict';

      function loadItem() {
        if (
          userSelected.EntraceHour !== undefined &&
          userSelected.ExitHours !== undefined
        ) {
          var timeEntrance = userSelected.EntraceHour.split(':');
          var timeExit = userSelected.ExitHours.split(':');

          $scope.entraceHour = new Date(
            1970,
            0,
            1,
            timeEntrance[0],
            timeEntrance[1],
            0
          );
          $scope.exitHours = new Date(1970, 0, 1, timeExit[0], timeExit[1], 0);
        } else {
          $scope.bntDelete = true;
        }
      }

      function cancelButton() {
        if ($scope.questionModalBool === true) {
          $scope.modalQuestion.close();
        } else if (
          $scope.questionModalBool === false &&
          $scope.deleteModalBool === true
        ) {
          $scope.modalDelete.close();
        } else if (
          $scope.questionModalBool === false &&
          $scope.deleteModalBool === false
        ) {
          $scope.modalError.close();
        }
      }

      function questionModal() {
        userCrudService
          .updateTimeCheck($state.params.id, $scope.startHour, $scope.endHour)
          .then(() =>
            swal
              .fire({
                title: $filter('translate')('SUCCESS'),
                icon: 'success',
                confirmButtonText: $filter('translate')('OK'),
              })
              .then(function () {
                userSelected.EntraceHour = $scope.startHour;
                userSelected.ExitHours = $scope.endHour;

                $scope.$apply();
                $scope.modalQuestion.close();
                $rootScope.timeCheckModal.close();
              })
          );
      }

      function save() {
        var startHour = document.getElementById('startHour').value;
        var endHour = document.getElementById('endHour').value;
        $scope.questionModalBool = false;

        if (startHour === '' || endHour === '') {
          $scope.messageTitle = $filter('translate')('ERROR');
          $scope.messageDescription =
            $filter('translate')('WHITE TIME MESSAGE');
          $scope.messageCancel = $filter('translate')('OK');
          $scope.questionModalBool = false;

          $scope.modalError = uibModal.open({
            scope: $scope,
            animationEnabled: true,
            backdrop: 'static',
            templateUrl: '/views/modal/errorModal/errorModal.html',
            controller: 'timecheckController',
            size: 'small',
            windowClass: 'modal-remove',
            resolve: {},
          });
        } else {
          if (endHour <= startHour) {
            $scope.messageTitle = $filter('translate')('INCORRECT TIMES');
            $scope.messageCancel = $filter('translate')('OK');
            $scope.messageDescription = $filter('translate')(
              'INCORRECT TIMES MESSAGE'
            );
            $scope.questionModalBool = false;

            $scope.modalError = uibModal.open({
              scope: $scope,
              animationEnabled: true,
              backdrop: 'static',
              templateUrl: '/views/modal/errorModal/errorModal.html',
              controller: 'timecheckController',
              size: 'small',
              windowClass: 'modal-remove',
              resolve: {},
            });
          } else {
            $scope.messageTitle = $filter('translate')('CHANGE');

            $scope.messageDescription = $filter('translate')(
              'CHANGE TIMES MESSAGE'
            );
            $scope.messageForward = $filter('translate')('YES');
            $scope.messageCancel = $filter('translate')('NO');
            $scope.questionModalBool = true;
            $scope.startHour = startHour;
            $scope.endHour = endHour;

            $scope.modalQuestion = uibModal.open({
              scope: $scope,
              animationEnabled: true,
              backdrop: 'static',
              templateUrl: '/views/modal/questionModal/questionModal.html',
              controller: 'timecheckController',
              size: 'small',
              windowClass: 'modal-remove',
              resolve: {
                userSelected: () => userSelected,
              },
            });
          }
        }
      }

      function _delete() {
        $scope.questionModalBool = false;

        $scope.deleteModalBool = true;
        $scope.messageTitle = $filter('translate')('CLEAR');
        $scope.messageDescription = $filter('translate')(
          'CLEAR TIMES PERMANENTLY'
        );
        $scope.messageForward = $filter('translate')('CLEAR');
        $scope.messageCancel = $filter('translate')('CANCEL');

        $scope.modalDelete = uibModal.open({
          scope: $scope,
          animationEnabled: true,
          backdrop: 'static',
          templateUrl: '/views/modal/deleteModal/deleteModal.html',
          controller: 'timecheckController',
          size: 'small',
          windowClass: 'modal-remove',
          resolve: {
            userSelected: () => userSelected,
          },
        });
      }

      function deleteModel() {
        userCrudService
          .deleteTimeCheck($state.params.id)
          .then(() =>
            swal
              .fire({
                title: $filter('translate')('SUCCESS'),
                icon: 'success',
                confirmButtonText: $filter('translate')('OK'),
              })
              .then(function () {
                userSelected.EntraceHour = undefined;
                userSelected.ExitHours = undefined;
                document.getElementById('startHour').value = '';
                document.getElementById('endHour').value = '';

                $rootScope.timeCheckModal.close();

                $scope.$apply();
                $scope.$close();
              })
          )
          .catch(function () {
            swal.fire({
              title: $filter('translate')('ERROR'),
              type: 'danger',
              confirmButtonText: $filter('translate')('AN ERROR OCCURRED'),
            });
          });
      }

      function run() {
        try {
          $scope.bntDelete = false;

          $scope.loadItem = logWrapper(
            loadItem,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.cancelButton = logWrapper(
            cancelButton,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.questionModal = logWrapper(
            questionModal,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.save = logWrapper(
            save,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.delete = logWrapper(
            _delete,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.deleteModel = logWrapper(
            deleteModel,
            runtimeConstant.isDebugControllersInternals
          );
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
